import React from 'react'
import { SchoolResultBadge } from './SchoolResultBadge'
import AcademicRatingBadge from './AcademicRatingBadge'

interface ISchoolResultBadgeGroupProps {
  results: any
  badgeStyle?: React.CSSProperties
  mathsRating?: number
  englishRating?: number
}

const SchoolResultBadgeGroup: React.FC<ISchoolResultBadgeGroupProps> = ({
  results,
  mathsRating,
  englishRating,
  badgeStyle = {},
}) => {
  if (!results && !mathsRating && !englishRating) {
    return null
  }
  if (
    !(
      results.pastYearsAvgDAs ||
      results.pastYearsAvgDAPercent ||
      results.pastYearsAvgMedianStudyScore ||
      results.pastYearsAvgOP1to5Percent ||
      results.pastYearsAvgMedianAtar ||
      results.pastYearsAvgNoOfStudentsWithAtar ||
      results.pastYearsAvgStudentsWithAtarPercent ||
      results.pastYearsAvgOver65AtarScorePercent ||
      mathsRating ||
      englishRating
    )
  ) {
    return null
  }
  return (
    <>
      {englishRating === 5 && (
        <AcademicRatingBadge style={badgeStyle} title="English" />
      )}
      {mathsRating === 5 && (
        <AcademicRatingBadge style={badgeStyle} title="Maths" />
      )}

      {/* NSW */}
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. DAs"
        results={results.pastYearsAvgDAs}
      />
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. DAs %"
        results={results.pastYearsAvgDAPercent}
        suffix="%"
      />

      {/* VIC */}
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. Median Score"
        results={results.pastYearsAvgMedianStudyScore}
      />

      {/* QLD */}
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. OP 1-5%"
        results={results.pastYearsAvgOP1to5Percent}
        suffix="%"
      />

      {/* WA */}
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. Median ATAR"
        results={results.pastYearsAvgMedianAtar}
      />
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. # of students with ATAR"
        results={results.pastYearsAvgNoOfStudentsWithAtar}
      />
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. students with ATAR %"
        results={results.pastYearsAvgStudentsWithAtarPercent}
        suffix="%"
      />

      {/* ACT */}
      <SchoolResultBadge
        style={badgeStyle}
        title="Avg. 65+ Score %"
        results={results.pastYearsAvgOver65AtarScorePercent}
        suffix="%"
      />
    </>
  )
}

export { SchoolResultBadgeGroup }
